module.exports = __webpack_public_path__ + "static/media/BR.23c03a16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/BR.svg
// module id = 2118
// module chunks = 7